import React from "react";
import './UpArrowIcon.css'

function UpArrowIcon() {
    return (
        <svg viewBox="0 0 12 7" xmlns="http://www.w3.org/2000/svg">
            <path d="m6.00712,0.07678l-0.57984,0.52341l-5.4495,4.98491l1.15747,1.36631l4.86967,-4.45468l4.87192,4.45468l1.15746,-1.36631l-5.44954,-4.98491l-0.57984,-0.52341l0.00219,0z"/>
        </svg>
    );
}

export default UpArrowIcon;